"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _useWindowDimensions = _interopRequireDefault(require("../hooks/useWindowDimensions"));

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/** This hook is used to calculate the position of the Popper to properly display all data */


var usePopperStyles = function usePopperStyles(options) {
  var anchorRef = options.anchorRef,
      popperElement = options.popperElement,
      _options$popperOrigin = options.popperOrigin,
      popperOrigin = _options$popperOrigin === void 0 ? {} : _options$popperOrigin,
      _options$anchorOrigin = options.anchorOrigin,
      anchorOrigin = _options$anchorOrigin === void 0 ? {} : _options$anchorOrigin;
  var windowDimensions = (0, _useWindowDimensions["default"])();
  /** This dummy state allows us to rerender the component that is using the hook */

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      setChanged = _useState2[1];

  var getElementRect = (0, _react.useCallback)(function (ref) {
    if (ref) {
      return ref.getBoundingClientRect();
    }

    return {
      bottom: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      width: 0,
      x: 0,
      y: 0
    };
  }, []);
  var getPopperPosition = (0, _react.useCallback)(function () {
    var anchorRect = getElementRect(anchorRef ? anchorRef.current : null);
    var popoverRect = getElementRect(popperElement);

    var getAnchorTop = function getAnchorTop() {
      switch (anchorOrigin.vertical) {
        case 'top':
          return anchorRect.top;

        case 'bottom':
          return anchorRect.top + anchorRect.height;

        default:
          return anchorRect.top + anchorRect.height / 2;
      }
    };

    var getPopperTopModifier = function getPopperTopModifier() {
      switch (popperOrigin.vertical) {
        case 'top':
          return 0;

        case 'bottom':
          return -popoverRect.height;

        default:
          return -popoverRect.height / 2;
      }
    };

    var getAnchorLeft = function getAnchorLeft() {
      switch (anchorOrigin.horizontal) {
        case 'left':
          return anchorRect.left;

        case 'right':
          return anchorRect.left + anchorRect.width;

        default:
          return anchorRect.left + anchorRect.width / 2;
      }
    };

    var getPopperLeftModifier = function getPopperLeftModifier() {
      switch (popperOrigin.horizontal) {
        case 'left':
          return 0;

        case 'right':
          return -popoverRect.width;

        default:
          return -popoverRect.width / 2;
      }
    };
    /** Avoid the case where the top position is outside window.height */


    var adjustTop = function adjustTop(top) {
      var height = windowDimensions.height;

      if (top < 0) {
        return 0;
      }

      if (top + popoverRect.height > height) {
        return height - popoverRect.height;
      }

      return top;
    };
    /** Avoid the case where the left/right position is outside window.width */


    var adjustLeft = function adjustLeft(left) {
      var width = windowDimensions.width;

      if (left < 0) {
        return 0;
      }

      if (left > width) {
        return width - popoverRect.width;
      }

      return left;
    };

    var styles = {
      position: 'fixed',
      top: adjustTop(getAnchorTop() + getPopperTopModifier()),
      left: adjustLeft(getAnchorLeft() + getPopperLeftModifier())
    };
    return styles;
  }, [popperElement, anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current, anchorOrigin === null || anchorOrigin === void 0 ? void 0 : anchorOrigin.horizontal, anchorOrigin === null || anchorOrigin === void 0 ? void 0 : anchorOrigin.vertical, popperOrigin === null || popperOrigin === void 0 ? void 0 : popperOrigin.horizontal, popperOrigin === null || popperOrigin === void 0 ? void 0 : popperOrigin.vertical, windowDimensions]);
  (0, _react.useEffect)(function () {
    /** Re-trigger render with position calc when resizing elements */
    var resizeObserver = new _resizeObserverPolyfill["default"](function () {
      setChanged(function (c) {
        return c + 1;
      });
    });

    if (popperElement) {
      resizeObserver.observe(popperElement);
    }

    if (anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current) {
      resizeObserver.observe(anchorRef.current);
    }
    /** Disconnect (delete) resize observer */


    return function () {
      if (popperElement) {
        resizeObserver.unobserve(popperElement);
      }

      if (anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current) {
        resizeObserver.unobserve(anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current);
      }

      resizeObserver.disconnect();
    };
  }, [getPopperPosition]);
  return getPopperPosition();
};

__signature__(usePopperStyles, "useWindowDimensions{windowDimensions}\nuseState{[, setChanged](0)}\nuseCallback{getElementRect}\nuseCallback{getPopperPosition}\nuseEffect{}", function () {
  return [_useWindowDimensions["default"]];
});

var _default = usePopperStyles;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(usePopperStyles, "usePopperStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Popper/usePopperStyles.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Popper/usePopperStyles.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();